import { Box } from "grommet";

export const MainContent = ({ children }: { children?: any }) => (
  <Box as={"main"} direction={"column"} pad={"small"} flex={{ grow: 1, shrink: 1 }} width={"100%"} overflow={"auto"}>
    {children}
  </Box>
);
